function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.35 0.458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.795,45.913a.318.318,0,0,0-.318.318v2.826a.956.956,0,0,1-.955.955H1.591a.956.956,0,0,1-.955-.955V40.763a.956.956,0,0,1,.955-.955H4.417a.318.318,0,0,0,0-.637H1.591A1.593,1.593,0,0,0,0,40.763v8.294a1.593,1.593,0,0,0,1.591,1.591h8.93a1.593,1.593,0,0,0,1.591-1.591V46.231A.318.318,0,0,0,11.795,45.913Zm0,0",
  transform: "translate(0 -37.933)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.733.68a1.432,1.432,0,0,0-2.025,0L109.03,6.358a.318.318,0,0,0-.082.14l-.747,2.7a.318.318,0,0,0,.392.392l2.7-.747a.318.318,0,0,0,.14-.082l5.678-5.678a1.434,1.434,0,0,0,0-2.025Zm-7.01,5.885,4.647-4.647,1.5,1.5-4.647,4.647Zm-.3.6,1.2,1.2-1.656.459Zm7.233-4.537-.338.338-1.5-1.5.338-.338a.8.8,0,0,1,1.125,0l.374.373A.8.8,0,0,1,116.657,2.629Zm0,0",
  transform: "translate(-104.746 -0.261)"
}));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.586,
    height: 13.523,
    viewBox: "0 0 13.586 13.523",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.761d24c2.svg";
export { ForwardRef as ReactComponent };